// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'

import MenuItem from '..'

import ContactSupportOutlinedIcon from '@material-ui/icons/ContactSupportOutlined'

class NTitleMe extends Component {

  render () {
    return (
      <MenuItem
        title='Product Details'
        buttonText={<><ContactSupportOutlinedIcon />Contact our sales team</>}
        href={'https://www.verimatrix.com/online-contact-form'}
      >
        <div className='ntitle-me product-details'>
          <div className='row title'>
            <p>Verimatrix TV Authentication lets rights owners and video service operators deliver the TV Everywhere experience that viewers want.</p>
          </div>
          <div className='row text'>
            <ul>
              <li className='lh'>{'NTitle Me key features include:'}</li>
              <li>{'Enables single point of integration with RESTful APIs to serve users across hundreds of Video Service Operators.'}</li>
              <li>{'Pre-integrated with 500+ global video service operators through direct connection or using major proxies.'}</li>
              <li>{'Supports open standards like SAML and OAuth2.0.'}</li>
              <li>{'Minimizes disruptions to viewing through single sign-on (SSO)'}</li>
              <li>{'Ensures viewing continuity through location and device-shifting technology'}</li>
            </ul>
          </div>
        </div>
      </MenuItem>
    )
  }
}

export default (NTitleMe)
